import { useEffect, useState } from 'react'

import _ from 'lodash'
import { FindItListQueryForPage } from 'types/graphql'

import { useLocation, useParams } from '@redwoodjs/router'

import { toast } from 'src/components/widgets/Toaster'
import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

export default function useItListCell(
  itList: FindItListQueryForPage['itList']
) {
  const { pathname } = useLocation()
  const { isAuthenticated } = useCurrentUser()
  const hasPurchasedItList = !_.isNil(itList.purchaseDate)
  const [locked, setLocked] = useState(
    !hasPurchasedItList && itList.relationship !== 'owner'
  )
  const itLists = (itList.creator.itLists || []).filter(
    (il) => il.id !== itList.id
  )

  const { unlocked } = useParams()
  useEffect(() => {
    if (unlocked === 'true') {
      if (!itList.price) {
        setLocked(false)
      } else if (!isAuthenticated) {
        history.replaceState(null, '', pathname)
      } else if (hasPurchasedItList) {
        setLocked(false)
      } else {
        toast('error', 'Please purchase this ItList to view its content')
        history.replaceState(null, '', pathname)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unlocked])

  return { locked, itLists, setLocked }
}
